import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../../../api";

const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token") || sessionStorage.getItem("accessToken");
    const uid = sessionStorage.getItem("uid");

    return {
        Authorization: token ? `Bearer ${token}` : "",
        uid,
    };
};

const useTreatmentDelegation = ({ endpoint, label, onUpdated }) => {
    const [enabled, setEnabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const loadDelegationSetting = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                    headers: getAuthHeaders(),
                });
                if (!response.ok) throw new Error("Impossible de charger la délégation.");
                const data = await response.json();
                setEnabled(!!data.enabled);
            } catch (error) {
                console.error(`Erreur chargement délégation ${label}:`, error);
            } finally {
                setLoaded(true);
            }
        };

        loadDelegationSetting();
        const reloadOnFocus = () => {
            if (document.visibilityState === "visible") loadDelegationSetting();
        };
        window.addEventListener("focus", reloadOnFocus);
        document.addEventListener("visibilitychange", reloadOnFocus);
        return () => {
            window.removeEventListener("focus", reloadOnFocus);
            document.removeEventListener("visibilitychange", reloadOnFocus);
        };
    }, [endpoint, label]);

    const toggle = async (nextEnabled) => {
        const result = await Swal.fire({
            title: nextEnabled ? "Activer la délégation ?" : "Désactiver la délégation ?",
            text: nextEnabled
                ? `Les demandes ${label} en attente seront transmises à l'Admin RH.`
                : "La transmission automatique vers l'Admin RH sera arrêtée.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: nextEnabled ? "#10b981" : "#dc2626",
            cancelButtonColor: "#6b7280",
            confirmButtonText: nextEnabled ? "Oui, activer" : "Oui, désactiver",
            cancelButtonText: "Annuler",
        });
        if (!result.isConfirmed) return;

        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}${endpoint}?enabled=${nextEnabled}`, {
                method: "POST",
                headers: getAuthHeaders(),
            });
            if (!response.ok) throw new Error("Impossible de mettre à jour la délégation.");
            const data = await response.json();
            setEnabled(!!data.enabled);
            if (onUpdated) onUpdated();
        } catch (error) {
            console.error(`Erreur délégation ${label}:`, error);
            await Swal.fire({
                icon: "error",
                title: "Erreur",
                text: error.message || "Impossible de mettre à jour la délégation.",
            });
        } finally {
            setLoading(false);
        }
    };

    return { enabled, loading, loaded, toggle };
};

export default useTreatmentDelegation;
